module.exports = __webpack_public_path__ + "img/avatar1.d05be9dd.png";